import { Intent } from '@blueprintjs/core';

export default function (error, options) {
  const title = 'This action is forbidden';
  const description = 'Performing the requested action is forbidden.';
  const message = 'The requested action is forbidden.';

  return {
    title,
    description,
    message,
    toast: true,
    intent: Intent.WARNING,
  };
}
